import { Component, Input, OnInit } from '@angular/core';
import { JsonDialogComponent } from "src/app/components/custom-forms/json-dialog/json-dialog.component";
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-select-and-display',
  templateUrl: './select-and-display.component.html',
  styleUrls: ['./select-and-display.component.css']
})
export class SelectAndDisplayComponent implements OnInit {

  selectedItem: any;
  _items: any[];

  @Input() set items(items: any[]){
    this._items = items;
    this.selectedItem = this._items.length > 0 ? this._items[0] : null;
  }

  @Input() displayNameFunction: Function = (item:any) => {
    if(item.hasOwnProperty("name")){
      return item.name;
    }
    else if(item.hasOwnProperty("text")){
      return item.text;
    }
    return "";
  }

  constructor(public dialog:MatDialog) { }

  ngOnInit(): void {
  }

  openDialog(obj: any){
    this.dialog.open(JsonDialogComponent, {
      data: obj,
      height: '600px',
      width: '800px'
    });
  }

}
